import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: runtimeConfig.appInsightsConnectionString,
    disableTelemetry: runtimeConfig.appInsightsEnabled,
    enableUnhandledPromiseRejectionTracking: true,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

appInsights.loadAppInsights();
const telemetryInitializer = (envelope: any) => {
  envelope.tags['ai.cloud.role'] = 'MemberCounselingCaseOverviewUi.Web';
};

appInsights.addTelemetryInitializer(telemetryInitializer);
export { reactPlugin, appInsights };
